// @ts-nocheck
import {useEffect, useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row, usePagination} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {usersColumns} from './columns/_columns'
import {User} from '../core/_models'
import {KTCardBody, KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../../../../modules/apps/user-management/users-list/core/ListViewProvider'
import {CustomRow} from './columns/CustomRow'
// import {gql, useQuery} from '@apollo/client'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import {AGENT_ACCOUNT_TYPE} from '../../../../../constant'
import axios from 'axios'
import {BASE_URL} from '../../../../../api'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {useSelector} from 'react-redux'

type SearchProps = {
  userSearch: String
  setUserSearch: Function
  loading?: boolean
  setLoading?: Function
  applyFilter?: boolean
  setApplyFilter?: Function
  onDataChange?: (data: any[]) => void
}

const UsersTable = ({
  sDate,
  eDate,
  genderFilter,
  setGenderFilter,
  userSearch,
  setUserSearch,
  page,
  setPage,
  loading: parentLoading,
  setLoading: setParentLoading,
  applyFilter,
  setApplyFilter,
  onDataChange,
}: SearchProps) => {
  let gender = genderFilter
  const [loadingTrue, setLoadingTrue] = useState<boolean>(false)
  const startDate = sDate == '' ? '' : new Date(sDate).toLocaleString()
  const endDate = eDate == '' ? '' : new Date(eDate).toLocaleString()
  // let paginationDetails = {}

  const [loading, setLoading] = useState<boolean>(true) // Add loading state
  const [userData, setUserData] = useState([]) // Store user data
  const [paginationDetails, setPaginationDetails] = useState({})
  const {p} = useParams()
  const navigate = useNavigate()

  const bookingsFilter = useSelector((state) => state.filter.bookingsFilter)

  useEffect(() => {
    // Fetch user data and pagination details when page or other filters change
    if (p && p > 0) {
      setPage(parseInt(p))
    }
    const fetchData = async () => {
      console.log('Page number is :  ', p)
      try {
        if (userSearch) {
          setPage(1)
        }
        const response = await axios.get(`${BASE_URL}/admin/bookings`, {
          params: {
            page: page,
            query: userSearch,
            startDate: bookingsFilter.startDate,
            endDate: bookingsFilter.endDate,
          },
        })
        const {docs, ...pagination} = response.data
        console.log('Response in booking : ', response)
        setUserData(docs)
        setPaginationDetails(pagination)
        setLoading(false) // Set loading to false once data is fetched

        // Notify parent component about data change
        if (onDataChange) {
          onDataChange(docs)
        }

        // Update parent loading state if provided
        if (setParentLoading) {
          setParentLoading(false)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false) // Set loading to false on error

        // Update parent loading state if provided
        if (setParentLoading) {
          setParentLoading(false)
        }
      }
    }

    fetchData()
  }, [userSearch, page, bookingsFilter, p, onDataChange, setParentLoading])

  const getSearchUsers = (filterkeyword) => {
    // const pattern = new RegExp('\\b' + clean(filterkeyword), 'i')
    // return AllUsersData.filter((x) => pattern.test(clean(x.first_name)))
    return userData
  }

  const searchUsers = getSearchUsers(userSearch)

  // Use searchUsers if available, otherwise use userData
  const displayData = searchUsers.length > 0 || userSearch ? searchUsers : userData

  const data = useMemo(() => displayData, [displayData])
  const columns = useMemo(() => usersColumns, [])
  console.log('Data for table: ', data)
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  console.log('rows', rows)

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<User>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={9}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <UsersListPagination
        page={page}
        setPage={setPage}
        totalPages={paginationDetails?.totalPages}
        loading={loading}
        paginationDetails={paginationDetails}
      />
      {loading && <UsersListLoading />}
      {/* {isFetching && <UsersListLoading />} */}
    </KTCardBody>
  )
}

export {UsersTable}
